import type { Topic } from '@/types/content';

export const topics: Topic[] = [
  {
    id: 'topic-1',
    title: '《姐姐的朋友》：一场关于暗恋与成全的成人童话',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20banner%20of%20two%20people%20standing%20at%20a%20rain%20streaked%20window%20overlooking%20a%20city%20at%20night%2C%20deep%20navy%20shadows%20with%20warm%20amber%20glow%2C%20soft%20bokeh%2C%20moody%20romantic%20widescreen%20composition%2C%20high%20detail&width=1400&height=700&seq=topic-jjdp-cover&orientation=landscape',
    intro: '从电影到剧集，「姐姐的朋友」系列用最克制的方式，讲述了成年人之间最难以言说的喜欢。这个专题汇集了围绕该系列的剧情解读、角色分析与主创访谈，带你重新走进那个雨天与公交站。',
    articleIds: ['article-1', 'article-2', 'article-3'],
    relatedTopicIds: ['topic-3', 'topic-4'],
  },
  {
    id: 'topic-2',
    title: '2025 暑期档观察：类型片的新解法',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20banner%20of%20a%20retro%20cinema%20marquee%20glowing%20at%20night%20with%20warm%20amber%20bulbs%20against%20a%20deep%20navy%20sky%2C%20nostalgic%20cinematic%20mood%2C%20minimalist%20widescreen%20composition%2C%20high%20detail&width=1400&height=700&seq=topic-summer-cover&orientation=landscape',
    intro: '这一年的暑期档，类型片正在悄悄改变。从科幻爱情到硬核冒险，创作者们尝试在类型框架里塞进更真诚的情感内核。这个专题带你回顾其中的亮点与趋势。',
    articleIds: ['article-4', 'article-5'],
    relatedTopicIds: ['topic-1', 'topic-3'],
  },
  {
    id: 'topic-3',
    title: '年度高分剧集盘点：值得二刷的十部作品',
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20banner%20of%20a%20cozy%20dark%20living%20room%20with%20a%20glowing%20screen%20and%20warm%20lamp%2C%20navy%20tones%20with%20amber%20accents%2C%20cinematic%20minimalist%20widescreen%20composition%2C%20high%20detail&width=1400&height=700&seq=topic-series-cover&orientation=landscape',
    intro: '评分高、口碑稳、细节耐看——我们按题材精选了今年最值得二刷的剧集，并附上每部的看点与适合的观影状态，帮你把时间花在真正的好故事上。',
    articleIds: ['article-6', 'article-7'],
    relatedTopicIds: ['topic-1', 'topic-4'],
  },
  {
    id: 'topic-4',
    title: '实力派演员幕后：角色诞生的过程',
    cover: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20editorial%20banner%20of%20a%20warm%20lit%20film%20set%20with%20cameras%20and%20softbox%20lights%2C%20navy%20shadows%20with%20amber%20glow%2C%20cinematic%20widescreen%20composition%2C%20high%20detail&width=1400&height=700&seq=topic-actor-cover&orientation=landscape',
    intro: '一个好角色背后，是无数看不见的准备。这个专题走进片场与排练室，记录演员们如何一点点把自己变成另一个人。',
    articleIds: ['article-8', 'article-9'],
    relatedTopicIds: ['topic-1', 'topic-3'],
  },
];